import React from 'react';
import { CdAndLpButton } from '~/Components/CdAndLp';
import { useExternalScript } from '~/utils/useExternalScript';

const ArtistBanner = ({ artistSlug, title = null }) => {
  const status = useExternalScript();

  // Render specific component for RIK artist
  if (artistSlug === 'RIK') {
    return (
      <div className="ArtistBanner-component" style={{ marginBottom: 20 }}>
        <h2>{title ? title : `Get the album re-release from RIK on Dream Chimney`}</h2>
        <a style={{ textAlign: 'center', margin: '20px auto 0 auto', display: 'block' }} data-totd-track-eventLabel="Matter of Time" href="https://dreamchimney.bandcamp.com/album/matter-of-time" target="_blank" rel="noopener noreferrer">
          <img src="//www.dreamchimney.com/mainpage/kba/kba-dc010-cass-v2.jpg" alt="RIK - Matter of Time" border="0" className="img-responsive" />
        </a>
      </div>
    );
  }

  // same for Sorcerer
  if (artistSlug === 'Sorcerer') {
    return (
      <div className="ArtistBanner-component" style={{ marginBottom: 20 }}>
        <h2>{title ? title : `Get the albums from Sorcerer on Dream Chimney`}</h2>
        <a style={{ textAlign: 'center', margin: '30px auto 0 auto', display: 'block' }} data-totd-track-eventLabel="Sorcerer - Sunlight Hits" href="https://dreamchimney.bandcamp.com/album/sunlight-hits" target="_blank" rel="noopener noreferrer">
          <img src="//www.dreamchimney.com/mainpage/kba/DC021-kba.jpg" alt="Sorcerer - Sunlight Hits" border="0" className="img-responsive" />
        </a>
      </div>
    );
  }

  // Add more artist-specific conditions here
  // if (artistSlug === 'ANOTHER_ARTIST') {
  //   return <AnotherArtistComponent />;
  // }

  // Default component for all other artists
  return (
    <div className="ArtistBanner-component">
      <h2>{title ? title : `Shop for Records/CDs`}</h2>
      <div className="banners_cdandlp"
        data-artist={artistSlug}
        data-format="11,12,13,14,16"
        data-position="H" data-nb="5" data-size="200"
        data-display="artist,title,format,price"
        data-language="auto"
        data-affiliate="dreamchimney"></div>
      <div style={{ marginBottom: 80 }}>
        <CdAndLpButton artist={artistSlug} />
      </div>
    </div>
  );
};

export default ArtistBanner;
